// Vendors
import React from 'react';
import MailOutline from '@mui/icons-material/MailOutline';
import SendOutlined from '@mui/icons-material/SendOutlined';
import StarOutline from '@mui/icons-material/StarOutline';
import AccessTime from '@mui/icons-material/AccessTime';
import DescriptionOutlined from '@mui/icons-material/DescriptionOutlined';
import FolderOpen from '@mui/icons-material/FolderOpen';
import DeleteOutline from '@mui/icons-material/DeleteOutline';
import DraftsOutlined from '@mui/icons-material/DraftsOutlined';
import MarkEmailUnreadOutlined from '@mui/icons-material/MarkEmailUnreadOutlined';
import Undo from '@mui/icons-material/Undo';
import MoreVert from '@mui/icons-material/MoreVert';
import ErrorOutlined from '@mui/icons-material/ErrorOutlined';
import Reply from '@mui/icons-material/Reply';
import ReplyAll from '@mui/icons-material/ReplyAll';
import Close from '@mui/icons-material/Close';
import Add from '@mui/icons-material/Add';
import ModeEditOutlined from '@mui/icons-material/ModeEditOutlined';
import OpenInNew from '@mui/icons-material/OpenInNew';
import Check from '@mui/icons-material/Check';
import NavigateBefore from '@mui/icons-material/NavigateBefore';
import NavigateNext from '@mui/icons-material/NavigateNext';
import UnsubscribeOutlinedIcon from '@mui/icons-material/UnsubscribeOutlined';

import { SvgIconProps } from '@mui/material/SvgIcon';

export const icons = {
    envelope: MailOutline,
    paperplane: SendOutlined,
    star: StarOutline,
    clock: AccessTime,
    paper: DescriptionOutlined,
    folder: FolderOpen,
    bin: DeleteOutline,
    openEnvelope: DraftsOutlined,
    envelopeWithDot: MarkEmailUnreadOutlined,
    undo: Undo,
    threeDotsVert: MoreVert,
    error: ErrorOutlined,
    reply: Reply,
    replyAll: ReplyAll,
    close: Close,
    plus: Add,
    arrowLeft: NavigateBefore,
    arrowRight: NavigateNext,
    pencil: ModeEditOutlined,
    openInNew: OpenInNew,
    check: Check,
    unsubscribe: UnsubscribeOutlinedIcon,
} as const;

export interface IconProps extends SvgIconProps {
    icon: keyof typeof icons;
}

const CustomIcon = ({ icon, ...props }: IconProps) => {
    const IconComponent = icons[icon];
    if (!IconComponent) {
        console.error(`Icon "${icon}" is not registered.`);
        return null;
    }
    return <IconComponent {...props} />;
};

export default CustomIcon;
